import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import updateStripePayment from './useUpdateStripePayment.request';
import { UpdateStripePaymentParams, UpdateStripePaymentResponse } from './useUpdateStripePayment.interface';

export default function useUpdateStripePayment(
    options?: UseMutationOptions<UpdateStripePaymentResponse, AxiosError<unknown>, UpdateStripePaymentParams>
) {
    return useMutation<UpdateStripePaymentResponse, AxiosError<unknown>, UpdateStripePaymentParams>({
        mutationFn: updateStripePayment,
        ...options,
    });
}
